import {ApolloLink} from 'apollo-link'
import setCookie from 'set-cookie-parser'
import {serialize} from 'cookie'

function getCookieLink({serverContext}) {
  const requestLink = new ApolloLink((operation, forward) => {
      if (serverContext) {
        const cookies = serverContext.state.cookies,
          cookieHeader = Object.keys(cookies.getAll())
            .map(key => serialize(key, cookies.get(key))).join('; ')

        operation.setContext(({headers}) => ({
          headers: {
            ...headers,
            Cookie: cookieHeader
          }
        }))
      }

      return forward(operation)
    }),

    responseLink = new ApolloLink((operation, forward) => {
      if (!serverContext) {
        return forward(operation)
      }

      return forward(operation).map(response => {
        const context = operation.getContext(),
          {response: {headers}} = context

        headers.getAll('set-cookie').forEach(header => {
          setCookie.parse(header).forEach(cookie => {
            const {name, value, ...options} = cookie

            serverContext.state.cookies.set(encodeURIComponent(name), encodeURIComponent(value), {
              httpOnly: false,
              secure: false,
              ...options
            })
          })
        })

        return response
      })
    })

  return requestLink.concat(responseLink)
}

export default getCookieLink
